import React from "react";
import { useSubmenu } from "../hooks/useSubmenu";
import { getDefaultMenuItems } from "../data/defaultMenuItems";
import type { NavBarProps } from "../types/navigation";
import NavBarLogo from "./NavBarLogo";
import NavBarMenu from "./NavBarMenu";
import NavBarContactButton from "./NavBarContactButton";
import Submenu from "./Submenu";

const NavBarContentDesktop: React.FC<NavBarProps> = ({
  menuItems = [],
  logoProps,
  contactAction,
  contactText = "Entrer Dans l'App",
}) => {
  const {
    activeSubmenu,
    submenuPosition,
    containerRef,
    menuRefs,
    handleMenuClick,
    handleMenuHover,
    handleMenuLeave,
    handleContainerLeave,
  } = useSubmenu();

  const currentMenuItems = menuItems.length > 0 ? menuItems : getDefaultMenuItems();

  const getActiveSubmenuItems = () => {
    const activeMenuItem = currentMenuItems.find((item) => item.key === activeSubmenu);
    return activeMenuItem?.submenu || [];
  };

  return (
    <div
      className="navbar-container relative hidden h-full w-full max-w-[1440px] flex-col items-center justify-center laptop:flex"
      onMouseLeave={handleContainerLeave}
      data-navbar-element
    >
      <div
        ref={containerRef}
        className="flex h-[90px] min-h-[90px] w-[90%] flex-row items-center justify-between rounded-[20px] border-[1.5px] border-muted bg-white px-3 4k-screen:min-h-[100px]"
        data-navbar-element
      >
        <NavBarLogo logoProps={logoProps} />

        <NavBarMenu
          menuItems={currentMenuItems}
          activeSubmenu={activeSubmenu}
          onMenuClick={handleMenuClick}
          onMenuHover={handleMenuHover}
          onMenuLeave={handleMenuLeave}
          menuRefs={menuRefs}
        />

        <NavBarContactButton contactAction={contactAction} contactText={contactText} />
      </div>

      {activeSubmenu && (
        <div
          className="submenu-container animate-in slide-in-from-top-2 absolute top-[93px] z-10 mt-2 min-h-[90px] w-[30%] rounded-[30px] border-[3px] border-muted bg-white shadow-lg transition-all duration-300 laptop:min-h-[100px]"
          style={{ left: `${submenuPosition}px` }}
          data-navbar-element
        >
          <Submenu items={getActiveSubmenuItems()} />
        </div>
      )}
    </div>
  );
};

export default NavBarContentDesktop;
